import { api, ApiRequestConfig } from 'api';
import { TConfigurator } from './types';

export type FetchConfiguratorsParams = {
	regionCode: string;
	categoryId: string;
	types?: 'project';
};

export const fetchConfigurators = (
	url: string,
	params: FetchConfiguratorsParams,
	config?: ApiRequestConfig
): Promise<{ configurators: TConfigurator[] }> => api.get(url, params, config);
